import { downloadBlob } from './download-blob';

export function downloadCsv(csv: string, filename: string): void {
  downloadBlob(
    new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' }),
    filename,
  );
}

export function promptExportFilename(
  orgName: string,
  collectionId: string,
  from: string,
  to: string,
): string {
  const safeOrg =
    orgName
      .trim()
      .replace(/[/\\:*?"<>|\s]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '') || 'org';
  const collectionPrefix = collectionId.includes('-')
    ? collectionId.split('-')[0]
    : collectionId.slice(0, 8);
  return `${safeOrg}_${collectionPrefix}_${from}_to_${to}.csv`;
}
